import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import { Link } from 'react-router-dom';
import user from '../../assets/user.png';
function ReviewItemVehicle({ data, NombreAvis, MeanRating }) {
  const dateString = data.createdAt;
  const dateObj = new Date(dateString);

  // Options de formatage pour afficher la date en français
  const options = {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };

  // Fonction pour obtenir la date formatée
  const formattedDate = dateObj.toLocaleDateString('fr-FR', options);
  return (
    <Link to={'#'}>
      <div className="border border-primary bg-body-tertiary rounded mb-2 w-100 d-md-block w-md-75">
        <div class="row p-2">
          <div class="col-md-3 col" style={{ width: '270px' }}>
            <img src={data.UserProfile.profile_url || user} alt="" width={'40px'} />
            <div>
              <Stack spacing={1} className="mb-3">
                <Rating name="size-large" value={data.rating} size="medium" readOnly />
              </Stack>
              <small className="text-muted">{formattedDate}</small>
            </div>
            {/* <p className="text-muted">34 avis. 3.0</p> */}
          </div>
          <div class="col-md-6 col text-muted">
            <h4>
              {' '}
              {data.UserProfile.firstName} {data.UserProfile.lastName}
            </h4>
            <p>{data.content}</p>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default ReviewItemVehicle;
